import React from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/layout/NavBar";
import Footer from "../components/layout/Footer";

import bgHero from "../images/bg-hero.png";
import svgArrowBtn from "../images/arrow-btn.svg";
import Logobgtransparentblack from "../images/DA_NoxZi/Logo-bg-transparent-black.png";

// =============================
// IMPORTE UNIQUEMENT CE QUI EXISTE
// =============================
// import pactePreview from "../images/projects/pacte/hero.png";
// import savoinimauxPreview from "../images/projects/savoinimaux/hero.png";
// import ajConstructionPreview from "../images/projects/aj-construction/hero.png";

import test from "../images/projects/teste.png"

// Si une image n'existe pas encore, ne l'importe pas.
// Mets simplement previewImage: null dans le tableau projects.

export default function ProjectsPage() {
  const projects = [
    {
      number: "01",
      title: "PACTE",
      category: "Application mobile",
      year: "2025",
      accent: "Produit digital local",
      previewImage: test || null,
      description:
        "Une application mobile pensée pour dynamiser le commerce local à travers un écosystème complet : fidélité digitale, messagerie, actualités locales, événements, notifications et expérience utilisateur premium.",
      details: [
        "Application iOS & Android",
        "Fidélité digitale",
        "Messagerie intégrée",
        "Actualités & événements",
      ],
      link: "/projects/pacte",
    },
    {
      number: "02",
      title: "Savoinimaux",
      category: "Site web",
      year: "2025",
      accent: "Refonte de présence digitale",
      previewImage: test || null,
      description:
        "Une refonte de site pensée pour offrir une image plus moderne, plus claire et plus crédible à l'association, avec une identité visuelle retravaillée et une présence digitale mieux structurée.",
      details: [
        "Refonte visuelle",
        "Site plus moderne",
        "Structure plus claire",
        "Image plus crédible",
      ],
      link: "/projects/savoinimaux",
    },
    {
      number: "03",
      title: "AJ Construction",
      category: "Présence digitale",
      year: "2026",
      accent: "Performance locale",
      previewImage: test || null,
      description:
        "Un accompagnement orienté visibilité locale, image professionnelle et performance digitale, avec un travail sur la présence en ligne, les contenus et la cohérence globale de la communication.",
      details: [
        "Visibilité locale",
        "Image professionnelle",
        "Optimisation digitale",
        "Stratégie de contenu",
      ],
      link: "/projects/aj-construction",
    },
  ];

  const values = [
    {
      title: "Des projets concrets",
      text: "Chaque réalisation répond à un besoin réel, avec une vraie logique d'usage, d'image et de performance.",
    },
    {
      title: "Une cohérence d'ensemble",
      text: "Nous pensons le design, la structure, la technique et la direction produit comme un tout.",
    },
    {
      title: "Une exigence durable",
      text: "L'objectif n'est pas seulement de livrer, mais de construire quelque chose de crédible et solide dans le temps.",
    },
  ];

  return (
    <div className="relative min-h-screen overflow-hidden bg-white text-black selection:bg-black selection:text-white">
      <div className="absolute inset-0 z-0 h-[100vh]">
        <img
          src={bgHero}
          alt="Background"
          className="w-full h-full object-cover pt-20"
        />
      </div>

      <NavBar />

      {/* HERO */}
      <section className="relative z-10 px-6 pt-20 pb-24 md:pt-24 md:pb-32 text-center">
        <div className="mb-6 flex items-center justify-center">
          <div className="rounded-full border border-black/10 bg-white/70 px-4 py-2 backdrop-blur-md shadow-[0_6px_20px_rgba(0,0,0,0.05)]">
            <p className="font-asap text-[12px] uppercase tracking-[0.28em] text-[#b98c42]">
              Nos projets
            </p>
          </div>
        </div>

        <h1 className="text-[2.2rem] md:text-[5.6rem] leading-[0.92] tracking-[-0.08em] font-[600] font-asap text-black max-w-6xl mx-auto">
          Des projets pensés,
          <br className="hidden md:block" />
          conçus et présentés
          <br className="hidden md:block" />
          avec exigence
        </h1>

        <p className="mt-7 text-[17px] md:text-[21px] text-black/60 max-w-3xl mx-auto font-asap leading-relaxed">
          Applications mobiles, sites web et accompagnements digitaux : une sélection
          de réalisations conçues avec une attention particulière portée à l'image,
          à l'expérience et à la cohérence globale.
        </p>

        <div className="mt-8 flex items-center justify-center gap-4 flex-wrap">
          <Link
            to="/contact"
            className="font-asap bg-black text-white px-6 py-3 rounded-full shadow-[0_9px_10px_rgba(0,0,0,0.25),_inset_0_2px_7.3px_#ffffff] hover:scale-[1.05] transition-transform inline-flex items-center gap-2"
          >
            Parler de votre projet
            <img src={svgArrowBtn} alt="Arrow" className="w-4 h-4 invert" />
          </Link>

          <Link
            to="/services"
            className="font-asap border border-black/20 text-black px-6 py-3 rounded-full hover:bg-black hover:text-white transition-all inline-flex items-center"
          >
            Voir nos services
          </Link>
        </div>

        <div className="mt-16 flex justify-center">
          <div className="relative w-full max-w-5xl overflow-hidden rounded-[36px] border border-white/40 bg-white/60 backdrop-blur-xl shadow-[0_24px_80px_rgba(0,0,0,0.08)] p-8 md:p-12">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(201,163,95,0.10),transparent_30%)]" />
            <div className="relative z-10 grid md:grid-cols-3 gap-6 text-left">
              {values.map((item) => (
                <div key={item.title}>
                  <p className="font-asap text-[11px] uppercase tracking-[0.24em] text-[#b98c42] mb-3">
                    {item.title}
                  </p>
                  <p className="font-asap text-black/75 leading-relaxed">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <div className="absolute top-[70vh] left-0 w-full h-96 bg-[linear-gradient(180deg,rgba(255,255,255,0)_4.41%,#fff_76.1%)] mix-blend-lighten z-20 pointer-events-none" />

      {/* INTRO */}
      <section className="relative z-10 px-6 py-16">
        <div className="max-w-5xl mx-auto">
          <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#b98c42] mb-5">
            Sélection de réalisations
          </p>
          <h2 className="text-[2.5rem] md:text-[5rem] leading-[0.95] tracking-[-0.075em] font-[600] font-asap text-black mb-7">
            Chaque projet reflète
            <br className="hidden md:block" />
            une intention claire
          </h2>
          <p className="text-[17px] md:text-[20px] text-black/60 font-asap leading-relaxed max-w-3xl">
            Derrière chaque réalisation, il y a une problématique précise, une
            direction visuelle, un niveau d'exigence technique et une volonté de
            construire une solution utile, crédible et durable.
          </p>
        </div>
      </section>

      {/* PROJECTS */}
      <section className="relative px-6 py-20 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 opacity-[0.03] [background-image:radial-gradient(#000_0.7px,transparent_0.7px)] [background-size:18px_18px]" />
          <div className="absolute top-12 left-[8%] w-72 h-72 rounded-full bg-[#c9a35f]/[0.06] blur-3xl" />
          <div className="absolute bottom-10 right-[8%] w-80 h-80 rounded-full bg-black/[0.03] blur-3xl" />
        </div>

        <div className="max-w-6xl mx-auto relative z-10 space-y-10">
          {projects.map((project) => {
            const hasPreview = Boolean(project.previewImage);

            return (
              <div
                key={project.title}
                className="group relative overflow-hidden rounded-[38px] border border-black/[0.06] bg-[linear-gradient(180deg,#ffffff_0%,#f7f7f7_100%)] p-6 md:p-8 shadow-[0_12px_30px_rgba(0,0,0,0.035)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_24px_70px_rgba(0,0,0,0.08)]"
              >
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(201,163,95,0.10),transparent_34%)] opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#c9a35f]/25 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />

                <div
                  className={`relative z-10 grid gap-8 items-center ${
                    hasPreview
                      ? "lg:grid-cols-[1.05fr_0.95fr]"
                      : "lg:grid-cols-1"
                  }`}
                >
                  {/* IMAGE */}
                  {hasPreview && (
                    <div className="relative order-1">
                      <div className="relative overflow-hidden rounded-[28px] border border-black/[0.06] bg-white shadow-[0_20px_60px_rgba(0,0,0,0.06)]">
                        <img
                          src={project.previewImage}
                          alt={project.title}
                          className="w-full h-[280px] md:h-[360px] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                          loading="lazy"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent" />
                      </div>
                    </div>
                  )}

                  {/* CONTENT */}
                  <div className={`order-2 ${!hasPreview ? "max-w-4xl" : ""}`}>
                    {/* <div className="flex items-start justify-between mb-8">
                      <span className="text-[64px] leading-none tracking-[-0.08em] font-[600] font-asap text-black/10">
                        {project.number}
                      </span>
                      <div className="w-12 h-12 rounded-full border border-black/[0.08] bg-[#f8f8f8] flex items-center justify-center shrink-0">
                        <img
                          src={Logobgtransparentblack}
                          alt="NoxZi"
                          className="w-5 h-5 object-contain opacity-80"
                        />
                      </div>
                    </div> */}

                    <p className="font-asap uppercase tracking-[0.24em] text-[10px] text-[#b98c42] mb-4">
                      {project.category}
                    </p>

                    <h2 className="text-[2rem] md:text-[3rem] leading-[0.95] font-[600] font-asap text-black mb-4">
                      {project.title}
                    </h2>

                    <div className="flex flex-wrap items-center gap-3 mb-6">
                      <span className="rounded-full border border-black/[0.08] bg-white px-4 py-2 text-[12px] uppercase tracking-[0.18em] font-asap text-black/70">
                        {project.year}
                      </span>
                      {project.accent && (
                        <span className="rounded-full border border-[#c9a35f]/20 bg-[#c9a35f]/[0.08] px-4 py-2 text-[12px] uppercase tracking-[0.18em] font-asap text-[#9a7130]">
                          {project.accent}
                        </span>
                      )}
                    </div>

                    <p className="text-black/65 font-asap leading-relaxed text-[16px] md:text-[18px] mb-6">
                      {project.description}
                    </p>

                    {Array.isArray(project.details) && project.details.length > 0 && (
                      <div className="grid sm:grid-cols-2 gap-3 mb-8">
                        {project.details.map((item) => (
                          <div
                            key={item}
                            className="rounded-[18px] border border-black/[0.06] bg-white/90 px-4 py-3 text-[14px] font-asap text-black shadow-[0_6px_18px_rgba(0,0,0,0.025)]"
                          >
                            {item}
                          </div>
                        ))}
                      </div>
                    )}

                    <div className="flex flex-wrap gap-4">
                      <Link
                        to={project.link}
                        className="inline-flex items-center justify-center gap-3 rounded-full bg-black text-white px-7 py-3.5 font-asap font-medium transition-all duration-300 hover:scale-[1.04]"
                      >
                        Voir le projet
                        <img
                          src={svgArrowBtn}
                          alt="Arrow"
                          className="w-4 h-4 invert"
                        />
                      </Link>

                      <Link
                        to="/contact"
                        className="inline-flex items-center justify-center rounded-full border border-black/15 px-7 py-3.5 font-asap font-medium text-black transition-all duration-300 hover:bg-black hover:text-white"
                      >
                        Créer un projet similaire
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* APPROACH */}
      <section className="relative px-6 py-32 bg-[linear-gradient(180deg,#fbfbfb_0%,#f3f3f3_100%)] overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 opacity-[0.03] [background-image:radial-gradient(#000_0.7px,transparent_0.7px)] [background-size:18px_18px]" />
          <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#c9a35f]/20 to-transparent" />
        </div>

        <div className="max-w-6xl mx-auto relative z-10 grid lg:grid-cols-[0.95fr_1.05fr] gap-14 items-center">
          <div className="relative">
            <div className="absolute -inset-6 rounded-[46px] bg-gradient-to-b from-[#c9a35f]/10 to-transparent blur-2xl opacity-70" />
            <div className="relative overflow-hidden rounded-[40px] border border-white/10 bg-black px-8 py-10 md:px-10 md:py-12 shadow-[0_35px_110px_rgba(0,0,0,0.22)]">
              <div className="absolute inset-0 opacity-[0.08]">
                <img src={bgHero} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="absolute inset-0 opacity-[0.035] [background-image:radial-gradient(#fff_0.7px,transparent_0.7px)] [background-size:18px_18px]" />
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(201,163,95,0.22),transparent_28%)]" />

              <div className="relative z-10">
                <p className="font-asap uppercase tracking-[0.28em] text-[10px] text-[#d1a75f] mb-4">
                  Notre manière de concevoir
                </p>
                <h3 className="text-[2rem] md:text-[2.8rem] leading-[0.98] tracking-[-0.06em] font-asap font-[500] text-white mb-5">
                  Chaque réalisation naît d'une logique produit, pas d'un simple habillage
                </h3>
                <p className="text-white/70 font-asap leading-relaxed text-[16px] md:text-[18px]">
                  Nous cherchons toujours à faire converger usage, image, lisibilité,
                  crédibilité et qualité technique dans une même direction.
                </p>
              </div>
            </div>
          </div>

          <div>
            <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#b98c42] mb-5">
              Ce que ces projets racontent
            </p>
            <h2 className="text-[2.8rem] md:text-[5.1rem] leading-[0.95] tracking-[-0.075em] font-[600] font-asap text-black mb-7">
              Une même exigence,
              <br className="hidden md:block" />
              appliquée à chaque contexte
            </h2>

            <div className="space-y-4">
              {[
                "Comprendre le besoin réel avant de proposer une solution",
                "Construire une direction visuelle cohérente avec l'identité du projet",
                "Développer des bases solides et évolutives",
                "Créer des expériences lisibles, utiles et crédibles",
              ].map((item, index) => (
                <div
                  key={item}
                  className="rounded-[22px] border border-black/[0.06] bg-white/95 px-5 py-4 font-asap text-black shadow-[0_6px_18px_rgba(0,0,0,0.03)]"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-9 h-9 rounded-full border border-black/[0.08] bg-[#f8f8f8] flex items-center justify-center text-[12px] tracking-[0.14em] font-asap font-[600] text-[#b98c42] shrink-0">
                      0{index + 1}
                    </div>
                    <p className="text-black/80 leading-relaxed">{item}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="px-6 pb-36">
        <div className="max-w-6xl mx-auto">
          <div className="relative overflow-hidden rounded-[48px] bg-black text-white px-8 py-16 md:px-14 md:py-24 shadow-[0_40px_120px_rgba(0,0,0,0.22)]">
            <div className="absolute inset-0 opacity-[0.10]">
              <img src={bgHero} alt="" className="w-full h-full object-cover" />
            </div>
            <div className="absolute inset-0 opacity-[0.035] [background-image:radial-gradient(#fff_0.7px,transparent_0.7px)] [background-size:18px_18px]" />
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(201,163,95,0.16),transparent_26%)]" />
            <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-[#c9a35f]/45 to-transparent" />

            <div className="relative z-10 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-12">
              <div className="max-w-3xl">
                <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#d1a75f] mb-5">
                  Votre projet, le prochain ?
                </p>
                <h2 className="text-[2.9rem] md:text-[5.5rem] leading-[0.94] tracking-[-0.08em] font-[600] font-asap mb-6">
                  Donnons vie à un projet à votre image
                </h2>
                <p className="text-white/70 text-[17px] md:text-[20px] font-asap leading-relaxed max-w-2xl">
                  Nous pouvons vous aider à cadrer, concevoir et développer une solution
                  digitale cohérente, élégante et réellement utile.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center gap-3 rounded-full bg-white text-black px-7 py-3.5 font-asap font-medium transition-all duration-300 hover:scale-[1.04]"
                >
                  Nous contacter
                  <img src={svgArrowBtn} alt="Arrow" className="w-4 h-4" />
                </Link>
                <Link
                  to="/services"
                  className="inline-flex items-center justify-center rounded-full border border-white/[0.18] px-7 py-3.5 font-asap font-medium text-white transition-all duration-300 hover:bg-white hover:text-black"
                >
                  Voir nos services
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}